import { render } from "./MiniWizardExpandableImplicitEditModeContent.vue?vue&type=template&id=97a7f884"
import script from "./MiniWizardExpandableImplicitEditModeContent.vue?vue&type=script&lang=js"
export * from "./MiniWizardExpandableImplicitEditModeContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__